import { useTheme } from 'styled-components';

import { Button, ButtonVariant } from '@/core/components/Button';
import { Icon } from '@/core/components/Icons';
import { Modal } from '@/core/components/Modal';
import { OverlayStyle } from '@/core/components/Modal/Modal.types';

import {
  Actions,
  Container,
  Description,
  IconContainer,
  TextContent,
  Title,
} from './SessionTakeoverModal.styles';
import { SessionTakeoverModalProps } from './SessionTakeoverModal.types';

export const SessionTakeoverModal = ({
  isOpen,
  onRedirectToLogin,
  onResetPassword,
}: SessionTakeoverModalProps) => {
  const theme = useTheme();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onRedirectToLogin}
      overlayStyle={OverlayStyle.BLUR}
      positionY="center"
    >
      <Container>
        <IconContainer>
          <Icon
            name="AlertAttentionDangerShield"
            color={theme.colors.teal}
            size={24}
          />
        </IconContainer>
        <TextContent>
          <Title>Session taken over</Title>
          <Description>
            Someone signed into your account from a different device or browser.
          </Description>
        </TextContent>
        <Actions>
          <Button
            variant={ButtonVariant.SECONDARY}
            onClick={onResetPassword}
          >
            Reset password
          </Button>
          <Button
            variant={ButtonVariant.PRIMARY}
            onClick={onRedirectToLogin}
          >
            Sign in again
          </Button>
        </Actions>
      </Container>
    </Modal>
  );
};
